import { Model } from 'caldera-immutable-model';
import Project from '../../models/Project';
import ProjectCollection from '../../models/ProjectCollection';

import type { ProjectObject } from './types';
import type { Id } from '../types';

type ProjectCollectionConvertible = ProjectObject[] | Project[] | ProjectCollection;
type ProjectConvertible = ProjectObject | Project;

export default class ProjectsState extends Model {

  _projects: ProjectCollection;

  constructor(data: any) {
    super(data);
    this._projects = new ProjectCollection(this.get('projects'));
  }

  // Projects

  get projects(): ProjectCollection {
    return this._projects;
  }

  setProjects(projects: ?ProjectCollectionConvertible): ProjectsState {
    return this.set('projects', projects);
  }

  addOrReplaceProject(project: ProjectConvertible): ProjectsState {
    return this.setProjects(this.projects.addOrReplaceById(project.id || project.uid, project));
  }

  removeProject(project: ProjectConvertible): ProjectsState {
    return this.setProjects(this.projects.removeById(project.id || project.uid));
  }

  // Fetching projects

  get isFetchingProjects(): boolean {
    return !!this.get('isFetchingProjects');
  }

  setIsFetchingProjects(isFetching: boolean): ProjectsState {
    return this.set('isFetchingProjects', isFetching);
  }

  // Creating project

  get isCreatingProject(): boolean {
    return !!this.get('isCreatingProject');
  }

  setIsCreatingProject(isCreating: boolean): ProjectsState {
    return this.set('isCreatingProject', isCreating);
  }

  // Current active project

  get activeProjectId(): ?Id {
    return this.get('activeProjectId');
  }

  setActiveProjectId(id: ?Id): ProjectsState {
    return this.set('activeProjectId', id);
  }

  get activeProject(): ?Project {
    // $FlowFixMe
    return this.projects.findById(this.activeProjectId);
  }

  setActiveProject(project: ?Project): ProjectsState {
    return this.setActiveProjectId(project ? project.id : null);
  }

  clearActiveProject() : ProjectsState {
    return this.set('activeProjectId', null)
  }
}



// WEBPACK FOOTER //
// ./src/redux/projects/ProjectsState.js